var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.626,
    height: 32.609,
    viewBox: "0 0 34.626 32.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2167",
    "data-name": "Group 2167",
    transform: "translate(-282.151 -194.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M299.466,226.642c-9.545,0-17.315-7.315-17.315-16.3s7.77-16.3,17.315-16.3,17.312,7.315,17.312,16.3S309.01,226.642,299.466,226.642Zm0-30.47c-8.292,0-15.04,6.355-15.04,14.165s6.747,14.165,15.04,14.165,15.037-6.355,15.037-14.165S307.758,196.173,299.466,196.173Z",
    transform: "translate(0 0)",
    fill: "#918f90"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_944",
    "data-name": "Rectangle 944",
    width: 1.801,
    height: 31.809,
    transform: "translate(298.732 194.433)",
    fill: "#918f90"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_945",
    "data-name": "Rectangle 945",
    width: 33.825,
    height: 1.8,
    transform: "translate(282.552 209.438)",
    fill: "#918f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M289.883,224c-10.976-14.755-.109-29.528,0-29.677l1.835,1.164c-.416.555-10.1,13.78,0,27.359Z",
    transform: "translate(3.17 1.259)",
    fill: "#918f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M291.2,224l-1.766-1.154c9.694-13.578.4-26.8,0-27.358l1.761-1.164C291.3,194.476,301.734,209.249,291.2,224Z",
    transform: "translate(14.605 1.259)",
    fill: "#918f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M285.415,208.847l-1.563-2.069c15.7-9.687,31.4-.094,31.563.006l-1.569,2.059C313.269,208.481,299.52,200.147,285.415,208.847Z",
    transform: "translate(-0.001 9.849)",
    fill: "#918f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M298.039,203.3a21.7,21.7,0,0,1-14.324-5.618l1.624-1.967c13.134,11.159,25.964.462,26.5,0l1.639,1.96C313.381,197.763,306.792,203.3,298.039,203.3Z",
    transform: "translate(0.402 5.073)",
    fill: "#918f90"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.6622010f595506caccb6a45bc51644a9.svg";
export { ForwardRef as ReactComponent };